import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import _ from 'lodash';
let NodesModelImpl = class NodesModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = [];
    }
    get nodeList() {
        return _.cloneDeep(this._modelData);
    }
    updateNodeList(nodeList) {
        this.updateData(nodeList);
    }
    dispose() {
        this.updateData([]);
    }
    updateData(data) {
        this.update(() => {
            return data;
        });
    }
};
NodesModelImpl = __decorate([
    injectable()
], NodesModelImpl);
export { NodesModelImpl };
